<template>
  <div>
    <div v-if="!dataloaded || !userDataLoaded" class="blackbox-loader"></div>

    <v-container v-if="dataloaded && userDataLoaded"  grid-list-md class="ma-0 pa-2" fluid>
      <v-layout row wrap>
        <v-flex md3 xs12 v-if="companies.length > 1 && !this.demoMode">
          <v-select
            class="ma-1"
            :items="filteredCompanies"
            :color="companyPrimaryColor"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"    
            item-text="name"
            item-value="id"
            v-on:input="loadBranches()"
            v-model="activeComp"
            no-data-text="Geen bedrijven gevonden."
            label="Selecteer bedrijf"
            outlined
            hide-details
            dense>
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content  class="pt-0" >
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    prepend-inner-icon="search"
                    clearable
                    v-model="searchCompanies"
                    hide-details
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div v-if="searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
              <v-divider v-if="searchCompanies.length > 0"></v-divider>
            </template>
          </v-select>
        </v-flex>
        <v-flex :class="branchesWidth" xs12>
          <v-select
            class="ma-1"
            :color="companyPrimaryColor"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"    
            :items="branches"
            item-text="branchName"
            item-value="id"
            v-model="selectedBranches"
            multiple
            outlined
            hide-details
            dense
            
            label="Vestiging"
          ></v-select>
        </v-flex>
        <v-flex v-if="branches.length > 1" md3 xs12>
          <v-btn
            class="ma-1"
            block
            height="40px"
            :depressed="branchesChanged"
            :disabled="branchesChanged"
            :color="companyPrimaryColor"
            @click="loadSelectedBranchesData()"
            >
            <span style="color: #fff;">Wachtrij laden</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <div v-if="deleting == true">
      <div class="loading-dots">
        <div class="loading-dots-loader"></div>
        <p class="loading-dots-text"> {{ deleteCounter }} van {{ selected.length }} verwijderd. </p>
      </div>
    </div>

    <div v-if="dataloaded && userDataLoaded && !deleting && clientQueue.length > 0" class="mt-5">
      <div class="content-box">
        <v-card>
          <v-card-title>
            <v-text-field
              style="max-width: 300px;"
              v-model="search"
              :color="companyPrimaryColor"
              placeholder="Zoeken"
              outlined
              hide-details     
              background-color="#fff"                                                
              prepend-inner-icon="search"
              autocomplete="disabled"
              clearable>
            </v-text-field>
            <v-spacer></v-spacer>
            <div class="header-edit-button" v-if="selected.length > 0">
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" fab darken color="secondary"  @click="deleteQueue()">
                    <v-icon  darken>delete</v-icon>
                  </v-btn>
                </template>
                <span style="color: #fff;">Cli&euml;nt<span style="color: #fff;" v-if="selected.length > 1">en</span> verwijderen van wachtrij</span>
              </v-tooltip>
            </div>
            <div class="header-edit-button">
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" fab darken color="primary" @click="addNewClientQueue()">
                    <v-icon darken>add</v-icon>
                  </v-btn>
                </template>
                <span style="color: #fff;">Voeg een nieuwe cli&euml;nt toe. </span>
              </v-tooltip>
            </div>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="clientQueue"
            :search="search"
            :itemsPerPage.sync="queuePages"
            v-model="selected"
            show-expand
            show-select
            single-expand
            hide-default-footer
            class="queue-table"
            :no-results-text="`Geen resultaten gevonden voor: ${search}`"
            >
            <template v-slot:item="{item, isSelected, select, isExpanded, expand}">
              <tr>
                <td>
                  <v-icon @click="select(true)" v-if="!isSelected">check_box_outline_blank</v-icon>
                  <v-icon @click="select(false)" v-if="isSelected" color="primary">check_box</v-icon>
                </td>
                <td>{{ item.name }}</td>
                <td>{{ item.phone }}</td>
                <td>{{ item.treatment }}</td>
                <td>{{ item.treatmentTime }}</td>
                <td>
                  <span v-for="(branchData, index) in branches" :key="index">
                    <span v-if="item.branch == branchData.id"> {{ branchData.branchName }}</span>
                  </span>
                </td>
                <td>{{ item.employee }}</td>
                <td>{{ item.queueEndDate.seconds | moment("D MMMM") }}</td>
                <td>
                  <v-tooltip v-if="item.salonhubId" bottom>
                    <template v-slot:activator="{on}">
                      <v-btn v-on="on"  style="float: right;" icon class="mx-0" @click="goToDossier(item.salonhubId)">
                        <v-icon color="grey">inbox</v-icon>
                      </v-btn>
                    </template>
                    <span style="color: #fff;">Dossier bekijken</span>
                  </v-tooltip>
                </td>
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                      <v-btn v-on="on"  style="float: right;" icon class="mx-0" @click="editClientQueueItem(item)">
                        <v-icon color="grey">edit</v-icon>
                      </v-btn>
                    </template>
                    <span style="color: #fff;">Bewerken</span>
                  </v-tooltip>
                </td>
                <td>
                  <span v-if="item.notes">
                    <v-tooltip v-if="!isExpanded" bottom>
                      <template v-slot:activator="{on}">
                        <v-btn  v-on="on" icon @click="expand(true)" ><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_more</v-icon></v-btn>
                      </template>
                      <span style="color: #fff;">Notities tonen</span>
                    </v-tooltip>

                    <v-tooltip v-if="isExpanded" bottom>
                      <template v-slot:activator="{on}">
                        <v-btn  v-on="on" icon @click="expand(false)" v-if="isExpanded"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_less</v-icon></v-btn>
                      </template>
                      <span style="color: #fff;">Notities verbergen</span>
                    </v-tooltip>
                    
                  </span>
                </td>
                
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                    <v-btn v-on="on" style="float: right;" icon class="mx-0" @click="checkClientQueueItem(item, index)">
                      <v-icon :color="$vuetify.theme.themes[theme].text" >check_box</v-icon>
                    </v-btn>
                    </template>
                    <span style="color: #fff;">Cli&euml;nt afvinken</span>
                  </v-tooltip>
                </td>

              </tr>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" style="padding: 0;">
                <v-card flat>
                  <v-card-text>
                    <b>Opmerkingen:</b><br>
                    {{ item.notes }}
                  </v-card-text>
                </v-card>
              </td>
            </template>
          </v-data-table>
        </v-card>

      </div>
    </div>

    <div style="width: 350px; margin: 50px auto;" v-if="dataloaded && userDataLoaded && !deleting && clientQueue.length == 0">
      <p>Er staan geen cli&euml;nten op de wachtlijst</p>
      <div class="text-center">
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn v-on="on" fab darken color="primary" style="display: block; margin: 15px auto;" @click="addNewClientQueue()">
              <v-icon darken>add</v-icon>
            </v-btn>
          </template>
          <span style="color: #fff;">Voeg een nieuwe cli&euml;nt toe. </span>
        </v-tooltip>
      </div>
    </div>

    <div v-if="clientQueueScheduled.length > 0" style="padding: 40px 0 0 0;">
      <h2 style="padding: 10px 0;">Succesvol ingeplande cli&euml;nten</h2>

      <div class="content-box">
        <v-data-table
          :headers="headersCompleted"
          :items="clientQueueScheduled"
          :itemsPerPage.sync="queuePages"
          show-expand
          single-expand
          hide-default-footer
          class="queue-table"
          >
          <template v-slot:item="{item, isExpanded, expand}">
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.treatment }}</td>
              <td>{{ item.treatmentTime }}</td>
              <td>
                <span v-for="(branchData, index) in branches" :key="index">
                  <span v-if="item.branch == branchData.id"> {{ branchData.branchName }}</span>
                </span>
              </td>
              <td>{{ item.employee }}</td>
              <td>
                <v-tooltip v-if="item.salonhubId" bottom>
                  <template v-slot:activator="{on}">
                    <v-btn v-on="on" style="float: right;" icon class="mx-0" @click="goToDossier(item.salonhubId)">
                      <v-icon color="grey">inbox</v-icon>
                    </v-btn>
                  </template>
                  <span style="color: #fff;">Dossier bekijken</span>
                </v-tooltip>
              </td>
              <td>
                <span v-if="item.notes">
                  <v-tooltip v-if="!isExpanded" bottom>
                    <template v-slot:activator="{on}">
                      <v-btn  v-on="on" icon @click="expand(true)" ><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_more</v-icon></v-btn>
                    </template>
                    <span style="color: #fff;">Notities tonen</span>
                  </v-tooltip>

                  <v-tooltip v-if="isExpanded" bottom>
                    <template v-slot:activator="{on}">
                      <v-btn  v-on="on" icon @click="expand(false)" v-if="isExpanded"><v-icon color="#251433" dark>expand_less</v-icon></v-btn>
                    </template>
                    <span style="color: #fff;">Notities verbergen</span>
                  </v-tooltip>
                </span>
              </td>
              <td>
                <v-icon color="green accent-2">check_box</v-icon>
              </td>
            </tr>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" style="padding: 0;">
              <v-card flat>
                <v-card-text>
                  <b>Opmerkingen:</b><br>
                  {{ item.notes }}
                </v-card-text>
              </v-card>
            </td>
          </template>
        </v-data-table>
      </div>
    </div>

    <!-- / New ClientQueue Dialog \ -->
    <v-dialog v-model="newQueueDialog" scrollable max-width="600px">
      <add-client-to-queue :branches="branches" @newQueueDialogChange="newQueueDialog = $event" @updateData="updateData()"></add-client-to-queue>
    </v-dialog>
    <!-- \ New ClientQueue Dialog / -->

    <!-- / Edit ClientQueue Dialog \ -->
    <v-dialog v-model="editQueueDialog" scrollable max-width="600px">
      <edit-client-to-queue :branches="branches" :selectedClientQueueItem="selectedClientQueueItem" :selectedClientQueueItemOriginal="selectedClientQueueItemOriginal" @editQueueDialogChange="editQueueDialog = $event" @updateData="updateData()"></edit-client-to-queue>
    </v-dialog>
    <!-- \ Edit ClientQueue Dialog / -->

  </div>
</template>


<script>
import { bus } from "../main";
import db from "../firebase/init";
import _lodash from "lodash";
import AddClientToQueue from "../components/modals/AddClientToQueue.vue";
import EditClientToQueue from "../components/modals/EditClientToQueue.vue";
import platform from 'platform'; 
import moment from 'moment';

export default {
  components: {
    "add-client-to-queue": AddClientToQueue,
    "edit-client-to-queue": EditClientToQueue
  },
  name: "ClientQueue",
  data: () => ({
    userDataLoaded: false,
    selectedBranchesOriginal: [],
    selectedBranches: [],
    selectedBranchesData: [],
    search: "",
    searchCompanies: "",
    selected: [],
    deleting: false,
    deleteCounter: 0,
    dataloaded: false,
    newQueueDialog: false,
    editQueueDialog: false,
    selectedClientQueueItem: {
      name: "",
      phone: "",
      treatment: "",
      branch: "",
      employee: "",
      salonhubId: "",
      queueEndDate: "",
      queueEndDateMoment: "",
      treatmenTime: "",
    },
    pagination: {
      rowsPerPage: "200",
      sortBy: "dateAdded.seconds",
      descending: false
    },
    clientQueue: [],
    clientQueueScheduled: [],
    selectedClientQueueItemOriginal: {},
    removeBookings: "",
    selected: [],
    branches: [],
    companies: [],
    queuePages: -1,
    headers: [
      {
        text: "Naam",
        align: "left",
        value: "name"
      },
      {
        text: "Telefoonnummer",
        align: "left",
        value: "phone"
      },
      {
        text: "Behandeling",
        align: "left",
        value: "treatment"
      },
      {
        text: "Tijd",
        align: "left",
        value: "treatmentType"
      },
      {
        text: "Salon",
        align: "left",
        value: "branch"
      },
      {
        text: "Medewerker",
        align: "left",
        value: "employee",
      },
      {
        text: "Einddatum",
        align: "left",
        value: "queueEndDate.seconds",
      },
      {
        text: "",
        align: "right",
        value: "salonhubId",
        sortable: false,
        width: "50px"
      },
      {
        text: "",
        value: "data-table-expand",
        align: "right",
        width: "70px",
        sortable: false
      },
      {
        text: "",
        align: "right",
        value: "edit",
        width: "50px",
        sortable: false,
      },
      {
        text: "",
        align: "right",
        value: "",
        width: "50px",
        sortable: false,
      }
    ],
    headersCompleted: [
      {
        text: "Naam",
        align: "left",
        value: "name"
      },
      {
        text: "Telefoonnummer",
        align: "left",
        value: "phone"
      },
      {
        text: "Behandeling",
        align: "left",
        value: "treatment"
      },
      {
        text: "Tijd",
        align: "left",
        value: "treatmentType"
      },
      {
        text: "Salon",
        align: "left",
        value: "branch"
      },
      {
        text: "Medewerker",
        align: "left",
        value: "employee",
      },
      {
        text: "",
        align: "right",
        value: "salonhubId",
        sortable: false,
        width: "50px"
      },
      {
        text: "",
        value: "data-table-expand",
        align: "right",
        width: "70px",
        sortable: false
      },
      {
        text: "",
        align: "right",
        value: "",
        width: "50px",
        sortable: false,
      }
    ]
  }),

  created() {
    this.loadUserComp();
  },

  methods: {
    loadUserComp() {
      this.userDataLoaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let dossierPackage = _.indexOf(doc.data().packages, 'dossier')
              if (dossierPackage >= 0) {
                let company = doc.data();
                company.id = doc.id;
                this.companies.push(company);
              }
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
        })
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.dataFilter.activeComp = this.companies[selectedCompanyIndex].id;
              console.log("selectedCompanyIndex: ", selectedCompanyIndex)
              this.loadBranches();
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.dataFilter.activeComp = this.companies[0].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadBranches();
            }
          }
          // No selected company is set 
          else {
            this.dataFilter.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadBranches();
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.dataFilter.activeComp = this.companies[0].id;
          this.loadBranches();
        }
      })
    },

    loadUserComp() {
      this.userDataLoaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let vm = this;
      let getUserCompData = getUserComp();

      async function getUserComp() {
        for (const company of userCompanies) {
          await db
            .collection("companies")
            .doc(company)
            .get()
            .then(doc => {
              console.log("doc.data(): ", doc.data())
              if (doc.data().apiItems.salonhub == true) {
                let company = {};
                company.name = doc.data().name;
                company.id = doc.id;
                if (doc.data().barometersSettings) {
                  company.barometersSettings = doc.data().barometersSettings;
                } else {
                  company.barometersSettings = {};
                }
                company.salonhubApiSettings = doc.data().salonhubApiSettings;
                company.benchmarkEmployees = doc.data().benchmarkEmployees;
                vm.companies.push(company);
              }
            });
        }
        vm.activeComp = vm.companies[0].id;
        vm.loadBranches();
      }
    },

    loadBranches() {
      console.log("load Branches");

      this.dataloaded = false;
      // Load active comp data
      this.companies.forEach(data => {
        if (data.id == this.activeComp) {
          this.activeCompData = data;
          this.activeCompDataOriginal = _.cloneDeep(data);
        }
      });

      // Load branches
      this.branches = [];
      this.selectedBranches = [];

      if (this.userRole == "employee" || this.userRole == "manager") {
        if (this.userBranches.length > 0) {
          this.selectedBranches = this.userBranches;
          let branchCounter = 0;
          new Promise((resolve, reject) => {
            this.selectedBranches.forEach(branch => {
              db.collection("branches")
                .doc(branch)
                .get()
                .then(doc => {
                  let branchCollection = doc.data();
                  branchCollection.id = doc.id;
                  this.branches.push(branchCollection);
                })
                .then(() => {
                  branchCounter++;
                  if (branchCounter == this.selectedBranches.length) {
                    resolve();
                  }
                });
            });
          }).then(() => {
            if (this.selectedBranches.length < 2) {
              this.loadSelectedBranchesData();
            } else {
              console.log(
                "Te veel branches. Gebruik buttom om data zelf te laden."
              );
              this.userDataLoaded = true;
              this.dataloaded = true;
              this.noData = true;
            }
          });
        } else {
          this.userDataLoaded = true;
          this.dataloaded = true;
          this.noData = true;
        }
      } else {
        db.collection("branches")
          .where("compId", "==", this.activeComp)
          .get()
          .then(snap => {
            snap.forEach(doc => {
              let branchCollection = doc.data();
              branchCollection.id = doc.id;
              this.branches.push(branchCollection);
              this.selectedBranches.push(doc.id);
              // this.selectedBranchesSalonhub.push(doc.data().branchNameSalonhub);
            });
          })
          .then(() => {
            this.loadSelectedBranchesData();
          });
      }
    },

    loadSelectedBranchesData() {
      this.dataloaded = false;
      this.selectedBranchesData = [];
      this.selectedBranchesSalonhub = [];
      this.selectedBranchesOriginal = _.cloneDeep(this.selectedBranches);

      if (this.selectedBranches.length != 0) {
        this.clientQueue = [];
        this.clientQueueScheduled = [];
        new Promise((resolve, reject) => {
          let today = new Date()
          let branchCounter = 0;
          this.selectedBranches.forEach(item => {
            db.collection("clientQueue")
            .where("queueEndDate",">", today)
            .where("branch", "==", item)
            .where("deleted.deleted","==", false)
            .get()
            .then(snap => {
              snap.forEach(doc => {
                if(doc.data().scheduled == true){
                  let client = doc.data();
                  client.id = doc.id;
                  this.clientQueueScheduled.push(client);
                } else {
                  let client = doc.data();
                  client.id = doc.id;
                  this.clientQueue.push(client);
                }
              });
            })
            .then(()=>{
              branchCounter++;
              if (branchCounter === this.selectedBranches.length) {
                resolve();
              }
            })
          });
        }).then(() => {
          this.userDataLoaded = true;
          this.dataloaded = true;
          this.noData = false;
        });
      } else {
        this.userDataLoaded = true;
        this.dataloaded = true;
        this.noData = true;
      }
    },

    updateData() {
      this.loadSelectedBranchesData();
    },

    deleteQueue() {
      this.deleting = true;
      let deletedObject = {
        deleted: true,
        deletedBy: this.userFirstName + " " + this.userLastName,
        deletedDate: new Date()
      }
      new Promise((resolve, reject) => {
        let counter = 0;
        this.selected.forEach(element => {
          db.collection("clientQueue")
            .doc(element.id)
            .update({
              deleted: deletedObject
            })
            .then(() => {
              counter++;
              this.deleteCounter++;
              if (counter == this.selected.length) {
                resolve();
              }
            })
            .catch(error => {
              console.error("Error removing log: ", error);
              counter++;
              this.deleteCounter++;
              if (counter == this.selected.length) {
                resolve();
              }
            });
        });
      }).then(() => {
        this.selected = [];
        this.deleteCounter = 0;
        this.loadSelectedBranchesData();
        bus.$emit("loadCompanyQueue");
        this.deleting = false;
      });
    },

    checkClientQueueItem(item, index){
      console.log("index: ", index)
      this.clientQueueScheduled.push(item)
      this.clientQueue.splice(index, 1)
      db.collection("clientQueue")
        .doc(item.id)
        .update({
          scheduled: true
        })
        .then(() => {
          db.collection("log").add({
            time: new Date(),
            logType: "info",
            user: this.userFirstName + " " + this.userLastName,
            userType: this.userRole,
            company: this.userCompany,
            actionType: "User Action",
            software: String(platform.os),
            browser: platform.name + ' ' + platform.version, 
            pillarrrVersion: this.$store.state.version,
            action: item.name + " succesvol ingepland vanuit wachtrij: " ,
            extra:
              "<b>Naam</b>: " +
              item.name +
              "<br>" +
              "<b>Doc Id</b>: " +
              item.id
          });
        })
        .then(()=>{
          bus.$emit("loadCompanyQueue");
        })
    },

    addNewClientQueue(){
      this.newQueueDialog = true
      bus.$emit("setQueueBranch");
    },

    editClientQueueItem(item) {
      this.selectedClientQueueItem = Object.assign({}, item);
      this.selectedClientQueueItem.queueEndDatePicker  = moment.unix(item.queueEndDate.seconds).format("YYYY-MM-DD");
      this.selectedClientQueueItemOriginal = _.cloneDeep(this.selectedClientQueueItem);
      this.editQueueDialog = true;
    },

    goToDossier(salonhubId){
      this.$router.push('/dossier?id='+ salonhubId)
    },


  },

  computed: {
    demoMode(){
      return this.$store.state.demoMode;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userBranches() {
      return this.$store.state.userBranches;
    }, 
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    filteredCompanies(){
      return this.companies.filter(company => {
        return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
      });
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    branchesChanged() {
      if (
        _.isEqual(this.selectedBranches, this.selectedBranchesOriginal) == false
      ) {
        return false;
      } else {
        return true;
      }
    },
    branchesWidth(){
      if(this.companies.length > 1 && !this.demoMode){
        return "md6"
      }
      else{
        return "md9"
      }
    }
  }
};
</script>
<style>
.company-package{
  display: list-item;
  margin: 0;
}

.company-package-list{
  padding: 5px 0;
}
</style>
